import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-team-form',
  templateUrl: './team-form.component.html',
  styleUrls: ['./team-form.component.scss']
})
export class TeamFormComponent {
  /**
   * Informs if loading is active or not
   */
  @Input() isLoading: boolean = false;

  /**
   * object of modal
   */
  @Input() modal: any;

  /**
   * Data of current user
   */
  @Input() selected?: any;

  /**
   * Data of Form
   */
  teamForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.createForm();
  }

  /**
   * Data selection action by clicking the form submit button
   */
  doSubmit() {
    this.modal.close({
      action: 'save',
      form: 'team',
      formData: this.teamForm.value
    });
  }

  /**
   *  Getter to access the form fields
   *
   *  @return AbstractControl
   */
  get f() {
    return this.teamForm.controls;
  }

  /**
   * Form creation and validation configuration
   */
  private createForm() {
    this.teamForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }
}
